import { __assign } from "tslib";
import React, { useCallback, useEffect, useContext, useRef } from 'react';
import classnames from 'classnames';
import { Waypoint } from 'react-waypoint';
import pick from 'lodash/pick';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '../../ErrorBoundary';
import { MobileContext } from '../../Context';
import { MeasuredCookieType } from '../../Measured';
import LoadingIndicator from '../../LoadingIndicator';
import DeviationTorpedo from '../DeviationTorpedo';
import s from './RecommendedTorpedo.scss';
/** How far does the user scroll before more deviations are loaded */
var DIST_FROM_BOTTOM_TO_LOAD_MORE = '1000px';
/** Default width of the torpedo if we can't get it from the DOM */
export var DEFAULT_DIMENSIONS = { width: 1024 };
/** Displays a torpedo filled with the same stream as the front page of browse:
 *  if you're logged in: 'recommended for you',
 *  if you're anon or don't have many favs: 'popular 24 hours'. */
var RecommendedTorpedo = function (props) {
    var className = props.className, title = props.title, _a = props.deviations, deviations = _a === void 0 ? [] : _a, hasMore = props.hasMore, isFetching = props.isFetching, initialize = props.initialize, fetchMore = props.fetchMore, errorMsg = props.errorMsg;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var containerRef = useRef(null);
    useEffect(function () {
        initialize();
    }, [initialize]);
    var onScrollToBottom = useCallback(function () {
        hasMore && !isFetching && fetchMore();
    }, [hasMore, isFetching, fetchMore]);
    var nothingToRecommend = !deviations.length && !hasMore;
    if (isMobile || nothingToRecommend) {
        return null;
    }
    var dimensions = containerRefToDimensions(containerRef);
    return (React.createElement(ErrorBoundary, null,
        React.createElement("div", { ref: containerRef, className: classnames(s['root'], className) },
            title && React.createElement("h3", { className: s['title'] }, title),
            React.createElement(DeviationTorpedo, { items: deviations, container: dimensions, cookieType: MeasuredCookieType.DEVIATION_PAGE_RECOMMENDED_TORPEDO, cookieDim: 'width' }),
            isFetching ? (React.createElement(LoadingIndicator, null)) : errorMsg ? (React.createElement("div", { className: s['error-msg'] },
                t('somethingWentWrong'),
                ": ",
                errorMsg)) : (React.createElement(Waypoint, { fireOnRapidScroll: false, bottomOffset: "-" + DIST_FROM_BOTTOM_TO_LOAD_MORE, onEnter: onScrollToBottom })))));
};
RecommendedTorpedo.displayName = 'RecommendedTorpedo';
export default RecommendedTorpedo;
/** Pulls width and height from DOM element falling back on defaults. */
export var containerRefToDimensions = function (containerElement, defaultDimensions) {
    if (defaultDimensions === void 0) { defaultDimensions = DEFAULT_DIMENSIONS; }
    var _a;
    var bounds = (_a = containerElement === null || containerElement === void 0 ? void 0 : containerElement.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    return __assign(__assign({}, defaultDimensions), pick(bounds, 'width', 'height'));
};
//# sourceMappingURL=RecommendedTorpedo.js.map